export const TOPIC = {
  water: 0,
  waste: 1,
  energy: 2,
  generalTitleSubtitle: 3,
  generalTitleSubtitleImage: 4,
  generalTitleImage: 5,
  generalImage: 6,
};
